import React from 'react';
import PropTypes from 'prop-types';

const Pager = ({
  currentPage,
  lastPage,
  handlePageChange,
}) => {
  const pagerItems = [];
  let minPagerItemNumber = currentPage === 1 ? 2 : currentPage;
  if (currentPage + 4 > lastPage) {
    minPagerItemNumber = lastPage - 4 > 1 ? lastPage - 4 : 2;
  }
  if (lastPage <= 5) {
    minPagerItemNumber = 2;
  }

  const maxPagerItemNumber = minPagerItemNumber + 3 < lastPage ? minPagerItemNumber + 3 : lastPage - 1;

  for (let i = minPagerItemNumber; i <= maxPagerItemNumber; i++) {
    const item = (
      <div
        key={i.toString()}
        className={`number ${currentPage === i ? 'active' : ''}`}
        onClick={() => handlePageChange(i)}
      >
        {i}
      </div>
    );
    pagerItems.push(item);
  }

  return (
    <div className="pagerOuter">
      <div className="pager">
        <div className="pagerLayout">
          <div
            className={`left pagerButton ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={() => handlePageChange(currentPage - 1)}
          />
          <div className="center">
            <div
              className={`number ${currentPage === 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(1)}>
              1
            </div>
            {minPagerItemNumber > 2 && (
              <div className="symbol">…</div>
            )}
            {pagerItems}
            {maxPagerItemNumber < lastPage - 1 && (
              <div className="symbol">…</div>
            )}
            {lastPage !== 1 && (
              <div
                className={`number ${currentPage === lastPage ? 'active' : ''}`}
                onClick={() => handlePageChange(lastPage)}
              >
                {lastPage}
              </div>
            )}
          </div>
          <div
            className={`right pagerButton ${currentPage === lastPage ? 'disabled' : ''}`}
            onClick={() => handlePageChange(currentPage + 1)}
          />
        </div>
      </div>
    </div>
  );
};

Pager.defaultProps = {
};

Pager.propTypes = {
  currentPage: PropTypes.number,
  lastPage: PropTypes.number,
  handlePageChange: PropTypes.func.isRequired,
};

export default Pager;
